<template>
    <div ref="chartRef" :style="{ width: width, height: height }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'EvidenceChart',
    props: {
        width: { type: String, default: '90%' },
        height: { type: String, default: '320px' },
        gain: { type: Array, default: () => [] },
        loss: { type: Array, default: () => [] },
    },

    mounted() {
        this.initChart();
    },

    watch: {
        gain: {
            deep: true,
            handler() {
                this.initChart();
            }
        },
        loss: {
            deep: true,
            handler() {
                this.initChart();
            }
        }
    },

    methods: {
        initChart() {
            if (!this.myChart) {
                this.myChart = echarts.init(this.$refs.chartRef);
            }

            // 把数据转换为 custom series 可用格式
            const gainData = this.gain.map(m => ({ value: [m, 0] }));
            const lossData = this.loss.map(m => ({ value: [m, 1] }));

            const barWidth = 1; // 0.7 分钟宽度的柱子

            const option = {
                animation: true,
                animationDuration: 600,

                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    formatter: params => {
                        const minute = params.value[0];
                        return `
        <div style="padding:4px 6px;">
          <div>${params.seriesName}</div>
          <div>第 ${minute} 分钟</div>
        </div>
      `;
                    }
                },

                grid: {
                    left: 50,
                    right: 50,
                    top: 40,
                    bottom: 40   // ⭐ 加大底部间距，避免文字被裁剪
                },

                xAxis: {
                    type: 'value',
                    min: 0,
                    max: 60,
                    name: '分钟',
                    nameGap: 25,
                    nameTextStyle: { color: '#BFD6E1', fontSize: 13 },

                    interval: 5,  // ⭐ 每 5 分钟显示一个刻度
                    axisLabel: {
                        color: '#A9C4D7',
                        fontSize: 12,
                        margin: 10,  // ⭐ 间距加大，避免文字重叠
                        formatter: v => `${v}`
                    },

                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#4A6FA5',  // ⭐ 更亮的颜色，能看见
                            width: 1.2
                        }
                    },

                    axisTick: {
                        show: true,
                        length: 6,
                        lineStyle: {
                            color: '#4A6FA5'
                        }
                    },

                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#2E4C6D',   // ⭐ 较亮的辅助线，可见性好
                            type: 'dashed'
                        }
                    },

                    boundaryGap: ['2%', '2%']  // ⭐ 避免最后刻度文字被裁剪
                },

                yAxis: {
                    type: 'category',
                    data: ['得分', '扣分'],
                    axisLabel: { color: '#A9C4D7', fontSize: 13 },
                    axisLine: { lineStyle: { color: '#4A6FA5' } }
                },

                series: [
                    {
                        name: '得分',
                        type: 'custom',
                        data: gainData,
                        renderItem: (params, api) => {
                            const minute = api.value(0);
                            const yIndex = api.value(1);
                            // const start = api.coord([minute - barWidth, yIndex]);
                            // const end = api.coord([minute + barWidth, yIndex]);
                            
                            const start = api.coord([minute , yIndex]);
                            const end = api.coord([minute + barWidth, yIndex]);

                            return {
                                type: 'rect',
                                shape: {
                                    x: start[0],
                                    y: start[1] - 12,
                                    width: end[0] - start[0],
                                    height: 24,
                                },
                                style: { fill: '#33E28A' } // 更亮的绿色
                            };
                        }
                    },

                    {
                        name: '扣分',
                        type: 'custom',
                        data: lossData,
                        renderItem: (params, api) => {
                            const minute = api.value(0);
                            const yIndex = api.value(1);
                            // const start = api.coord([minute - barWidth, yIndex]);
                            // const end = api.coord([minute + barWidth, yIndex]);
                            
                            const start = api.coord([minute , yIndex]);
                            const end = api.coord([minute + barWidth, yIndex]);

                            return {
                                type: 'rect',
                                shape: {
                                    x: start[0],
                                    y: start[1] - 12,
                                    width: end[0] - start[0],
                                    height: 24,
                                },
                                style: { fill: '#FF5C5C' } // 更亮的红色
                            };
                        }
                    }
                ]
            };

            this.myChart.setOption(option);
            window.addEventListener('resize', this.myChart.resize);
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.myChart?.resize);
        this.myChart?.dispose();
    }
};
</script>

<style scoped></style>
